



















import { Component, Prop, Vue } from 'vue-property-decorator'

import { ModalState, QrCodeResourcePayload } from '@/models'

import QrCodeForm from './QrCodeForm.vue'

@Component({
  components: {
    QrCodeForm
  }
})
export default class CreateQrCodeModal extends Vue {
  @Prop({ type: ModalState, required: true })
  readonly modalState!: ModalState

  @Prop({ type: Number, required: true })
  readonly businessUnitId!: number

  data: QrCodeResourcePayload | null = null
  isValid = false

  cancel () {
    this.modalState.reset()

    this.data = null

    this.$emit('cancel')
  }

  submit () {
    if (this.data && this.isValid) {
      this.$emit('submit', this.data)
    }
  }

  submitAndClose () {
    this.modalState.isActive = false
    this.submit()
  }
}
